<style lang="stylus">
    .outputSvg-mask
        modal-mask()
        .outputSvg-modal
            width 480px
            .outputSvg-container
                .outputSvg-box
                    display flex
                    flex-wrap wrap
                    margin-bottom 12px
                    .outputSvg-optionbox-title
                        font-size 12px
                        line-height 24px
                        width 70px
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                    .right
                        width calc(100% - 76px)
                        margin-left 6px
                        position relative
                        display flex
                        flex-wrap wrap
                        align-items center
                        .check-box-item
                            height 24px
                            padding 0 16px
                            border 1px solid var(--border-color-gray-10)
                            border-radius 6px
                            margin 0 16px 8px 0
                            display flex
                            align-items center
                            &:last-child
                                margin-right 0
                            &.checked
                                position relative
                                border-color var(--themeColor)
                                .tick-icon
                                    display block
                            &:hover
                                border-color var(--themeColor)
                            .tick-icon
                                display none
                                position absolute
                                top 0
                                right 0
                                height 18px
                                width 18px;
                                color var(--themeColor)
                            .vip-icon
                                margin-right 8px
                                width 12px
                                height 12px
                        .selectInput-label
                            position absolute
                            display flex
                            align-items center
                            top 6px
                            right 16px
                            z-index -1
                    .ivu-select-disabled
                        .ivu-select-selection
                            background-color var(--bg-color-ivu-input-number-input-disabled)
                    .ivu-select-selection
                        width 100%
                        background-color transparent
                    .outputSvg-selector
                        .ivu-select-item
                            display flex
                            align-items center
                            position relative
                        .vip-icon
                            margin-left 8px
                    .outputSvg-shapebox
                        padding-bottom 12px
                        border-bottom 1px solid var(--border-color-gray-10)
            .ivu-select-dropdown
                padding 6px
                box-shadow 0px 0px 4px rgba(0, 0, 0, 0.05), 0px 2px 10px rgba(0, 0, 0, 0.08)
                border-radius 8px
            .ivu-select-arrow
                right 2px
            .dialog-btnbox-normal
                margin-top 104px
</style>

<template>
    <div class="outputSvg-mask">
        <Dialog class="outputSvg-modal" :title="$t('title')" :isShow="true" @ok="confirm" @close="cancel">
            <div class="outputSvg-container">
                <div class="outputSvg-shapebox outputSvg-box">
                    <p class="outputSvg-optionbox-title" :title="$t('subTitle-name')">{{ $t("subTitle-name") }}</p>
                    <Input class="right" v-model="fileName" size="small" :placeholder="fileNameSync" :disabled="EDCONFIG.IS_SDK" />
                </div>
                <div class="outputSvg-shapebox outputSvg-box">
                    <p class="outputSvg-optionbox-title">{{ $t("subTitle-range") }}</p>
                    <div class="right">
                        <i-select class="outputSvg-selector" v-model="shapeRadio" size="small" @on-change="setShapeLabelLeft">
                            <i-option
                                v-for="item in shapeList"
                                :value="item.id"
                                :key="item.id"
                                :label="$t(item.name)"
                                :disabled="item.id == 2 && !isSel"
                            >
                                <span>{{ $t(item.name) }}</span>
                                <VipIcon v-if="!vip && item.showVip" />
                            </i-option>
                        </i-select>
                        <div class="selectInput-label" ref="selectShapeInputLabel" v-if="shapeRadio !== 0 && shapeRadio !== 1 && !vip">
                            <VipIcon />
                        </div>
                    </div>
                </div>
                <div class="outputHtml-watermarkBox outputSvg-box">
                    <p class="outputSvg-optionbox-title" :title="$t('subTitle-watermark')">{{ $t("subTitle-watermark") }}</p>
                    <div class="right">
                        <div
                            v-for="item in watermarkList"
                            :key="item.id"
                            class="check-box-item"
                            :class="{ checked: item.id == watermarkSetting }"
                            @click="changeWatermarkSetting(item.id)"
                        >
                            <VipIcon v-if="!vip && item.showVip" />
                            <span>{{ $t(item.name) }}</span>
                            <iconSymbol name="export-tick-top" class="tick-icon" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div @click="cancel">{{ $t("cancel") }}</div>
                <div class="dialog-btn-ok" @click="beforeConfirm">
                    <span>{{ $t("export") }}</span>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
        },
    })
    export default class outputSvg extends Vue {
        @Inject()
        ["fileRename"];
        shapeRadio = 0;
        fileName = window["_view"]._doc._fileName;
        shapeList = [
            {
                id: 0,
                name: "currentPage",
            },
            {
                id: 1,
                name: "allPage",
            },
            {
                id: 2,
                name: "selectShape",
                showVip: true,
            },
        ];
        watermarkSetting: number = 1;
        watermarkList = [
            {
                id: 0,
                name: "default",
            },
            {
                id: 1,
                name: "nonwatermark",
                showVip: true,
            },
        ];
        get isSel() {
            return this.$store.state.shape.isActived;
        }
        calcTextWidth(text: string) {
            const font = "12px 'Noto Sans SC', 'Noto Sans', 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif";
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context.font = font;
            const { width } = context.measureText(text);
            return width;
        }
        setShapeLabelLeft() {
            let item = this.shapeList.filter((item) => item.id === this.shapeRadio) as any;
            let textWidth = this.calcTextWidth(String(this.$t(item[0].name)));
            this.$nextTick(() => {
                this.$refs.selectShapeInputLabel && ((this.$refs.selectShapeInputLabel as HTMLElement).style.left = textWidth + 8 + 8 + "px");
            });
        }
        changeWatermarkSetting(id: number) {
            this.watermarkSetting = id;
        }
        beforeConfirm() {
            this.fileRename(this.fileName).then(() => {
                this.confirm();
            });
        }
        confirm() {
            this.setExporCustomPrefer();
            if ((this.watermarkSetting == 1 || this.shapeRadio == 2) && !this.vip) {
                let area = ["Currentpage", "Allpage", "Shape"][this.shapeRadio],
                    watermark = this.watermarkSetting ? "Nomark" : "Default";
                let triggerName = `svg_${area}_${watermark}`;
                if (window.EDCONFIG.IS_SDK) {
                    triggerName += "_exportSth";
                }
                this.$openBuyPage(triggerName);
                return;
            }
            let view = window["_view"];
            if (!view) return;
            this.$pcTrack("saveFileProcess_pickAnExportType", `fileType: svg`);
            this.sensors.track("pickAnExportType", {
                Catalogues: "saveFileProcess",
                savesource: "exportSave",
                file_type: "svg",
            });
            this.sensors.track("exportSuccess", {
                Catalogues: "saveFileProcess",
                savesource: "exportSave",
                file_type: "svg",
                export_order: 1,
            });
            let saveToInclowdz = (data) => {
                let reader = new FileReader();
                reader.onload = function (e) {
                    window.parent.postMessage(
                        {
                            mode: "iframe2parent",
                            target: "file",
                            action: "export",
                            type: "request",
                            session_id: "0000000003",
                            version: "v1",
                            data: {
                                filename: data.name,
                                filesize: data.size,
                                base64_data: (<any>e.target).result,
                            },
                        },
                        "*"
                    );
                };
                reader.readAsDataURL(data.blob);
            };
            // if(this.isInclowdz) {
            //     view.saveToSvg(this.shapeRadio, false, saveToInclowdz);
            // } else {
            let haswatermark = this.watermarkSetting == 1 ? false : true;
            view.saveToSvg(this.shapeRadio, haswatermark);
            // }
            this.cancel();
        }
        cancel() {
            this.closeModal();
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        get fileNameSync() {
            return this.$store.state.ui.fileNameSync;
        }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        // 用户偏好
        get customPreferContent() {
            return this.$store.state.ui.customPreferContent;
        }
        set customPreferContent(v) {
            this.$store.commit("setStatus", {
                type: "customPreferContent",
                data: v,
            });
        }
        setExporCustomPrefer() {
            let data = this.customPreferContent || {};
            if (data["defaultExportSVGWatermark"] === this.watermarkSetting && data["defaultExportSVGRange"] === this.shapeRadio) return;
            Object.assign(data, {
                defaultExportSVGWatermark: this.watermarkSetting,
                defaultExportSVGRange: this.shapeRadio,
            });
            this.customPreferContent = data;
            let jsonStr = JSON.stringify(data);
            let params = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
                obj: { content: jsonStr },
            };
            this.$edApi.updateUserPrefer(params);
        }
        mounted() {
            this.$nextTick(() => {
                // 获取用户最后一次水印选项 默认无水印
                this.watermarkSetting = this.customPreferContent?.["defaultExportSVGWatermark"] === 0 ? 0 : 1;
                // 获取用户最后一次导出范围选项
                this.shapeRadio = this.customPreferContent?.["defaultExportSVGRange"] || 0;
            });
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "导出为SVG",
    "subTitle-name": "文件名称：",
    "subTitle-range": "导出范围：",
    "subTitle-watermark": "水印设置：",
    "export": "导出",
    "cancel": "取消",
    "default": "默认",
    "nonwatermark": "无水印",
    "currentPage": "当前页面",
    "selectShape": "选中的形状",
    "allPage": "所有页面"
  },
  "en": {
    "title": "Export to SVG",
    "subTitle-name": "File Name:",
    "subTitle-range": "Export range:",
    "subTitle-watermark": "Watermark settings:",
    "export": "Export",
    "cancel": "Cancel",
    "default": "Default",
    "nonwatermark": "No watermarks",
    "currentPage": "Current page",
    "selectShape": "Selected shape",
    "allPage": "All pages"
  },
  "fr": {
    "title": "Exporter au format SVG",
    "subTitle-name": "Nom de fichier:",
    "subTitle-range": "Plage d'exportation:",
    "subTitle-watermark": "Paramètres de filigrane:",
    "export": "Exporter",
    "cancel": "Annuler",
    "default": "Par défaut",
    "nonwatermark": "Aucun filigrane",
    "currentPage": "Page actuelle",
    "selectShape": "Formes Sélectionnées",
    "allPage": "Toutes les Pages"
  },
  "de": {
    "title": "Als SVG exportieren",
    "subTitle-name": "Dateiname:",
    "subTitle-range": "Exportbereich:",
    "subTitle-watermark": "Wasserzeicheneinstellungen:",
    "export": "Exportieren",
    "cancel": "Abbrechen",
    "default": "Standard",
    "nonwatermark": "Kein Wasserzeichen",
    "currentPage": "Aktuelle Seite",
    "selectShape": "Gewählte Form",
    "allPage": "Alle Seite"
  },
  "jp": {
    "title": "SVGにエクスポート",
    "subTitle-name": "ファイル名：",
    "subTitle-range": "範囲をエクスポート:",
    "subTitle-watermark": "透かし設定: ",
    "export": "エクスポート",
    "cancel": "キャンセル",
    "default": "デフォルト",
    "nonwatermark": "透かしなし",
    "currentPage": "現在のページ",
    "selectShape": "選択中の図形",
    "allPage": "すべてのページ"
  },
  "es": {
    "title": "Exportar a SVG",
    "subTitle-name": "Nombre de Archivo:",
    "subTitle-range": "Rango de exportación:",
    "subTitle-watermark": "Configuración de marca de agua:",
    "export": "Exportar",
    "cancel": "Cancelar",
    "default": "Estándar",
    "nonwatermark": "Sin marca de agua",
    "currentPage": "Página Actual",
    "selectShape": "Formas seleccionadas",
    "allPage": "Todas las páginas"
  },
  "pt": {
    "title": "Exportar para SVG",
    "subTitle-name": "Nome do Arquivo:",
    "subTitle-range": "Intervalo de exportação:",
    "subTitle-watermark": "Configurações de marca d'água:",
    "export": "Exportar",
    "cancel": "Cancelar",
    "default": "Padrão",
    "nonwatermark": "Sem marcas d'água",
    "currentPage": "Pagina Atual",
    "selectShape": "Formas selecionadas",
    "allPage": "Todas as páginas"
  },
  "it": {
    "title": "Esporta in SVG",
    "subTitle-name": "Nome File:",
    "subTitle-range": "Forma：",
    "subTitle-range": "Range dell'esportazione:",
    "subTitle-watermark": "Impostazioni filigrana:",
    "export": "Esporta",
    "cancel": "Annulla",
    "default": "Predefinito",
    "nonwatermark": "Nessuna filigrana",
    "currentPage": "Pagina Corrente",
    "selectShape": "Forme Selezionate",
    "allPage": "Tutte le Pagine"
  },
  "tw": {
    "title": "匯出為SVG",
    "subTitle-name": "檔案名稱：",
    "subTitle-range": "匯出範圍：",
    "subTitle-watermark": "浮水印設定：",
    "export": "匯出",
    "cancel": "取消",
    "default": "默認",
    "nonwatermark": "無水印",
    "currentPage": "當前頁面",
    "selectShape": "選中的形狀",
    "allPage": "所有頁"
  },
  "kr": {
    "title": "SVG로 내보내기",
    "subTitle-name": "파일 이름:",
    "subTitle-range": "내보내기 범위:",
    "subTitle-watermark": "워터마크 설정:",
    "export": "내보내기 ",
    "cancel": "취소 ",
    "default": "기본",
    "nonwatermark": "워터마크 없음",
    "currentPage": "현재 페이지",
    "selectShape": "선택한 모양",
    "allPage": "모든 페이지"
  },
  "id": {
    "subTitle-range": "Rentang ekspor:",
    "subTitle-watermark": "Pengaturan watermark:"
  }
}
</i18n>
